const global = {
  API_URL: 'https://api.proteacoin.link',
  //API_URL: 'https://qaapi.proteacoin.link',
  // API_URL: 'https://996v4qqen4.execute-api.af-south-1.amazonaws.com/dev',
  // API_URL: 'https://rgw5ee44qc.execute-api.af-south-1.amazonaws.com/prod',
  API_AUTH_KEY: '',
  CLIENT: 'Protea Coin',
};
export default global;
